import { EnumLabelType } from "@/Domain/EnumLabelType";

export function getKeyFromValue<T>(
  enumType: T,
  value: string
): keyof T | undefined {
  const keys = Object.keys(enumType) as Array<keyof T>;
  const foundKey = keys.find((key) => (enumType[key] as any) == value);
  return foundKey;
}

export function splitByCapitalLetter<T extends string | number>(
  value: T
): string {
  if (!value) return "";

  return value
    .toString()
    .split(/(?=[A-Z])/)
    .join(" ");
}

export function joinByCapitalLetter<T extends object>(
  enumType: T,
  value: string
): keyof T | undefined {
  const keys = Object.keys(enumType) as Array<keyof T>;
  const normalizedValue = value.trim().toLowerCase();

  const foundKey = keys.find((key) => {
    const splitKey = splitByCapitalLetter(key as string).toLowerCase();
    return splitKey === normalizedValue;
  });

  return foundKey;
}

export const getLabelTypeString = function (labelType: EnumLabelType) {
  if (!labelType) return "";

  switch (labelType) {
    case EnumLabelType.InHouse:
      return "In-House";
    case EnumLabelType.PrivateLabel:
      return "Private Label";
    default:
      return EnumLabelType[labelType].toString();
  }
};

export const getLabelTypeFromString = function (labelType: string) {
  if (!labelType) return null;

  const normalizedValue = labelType.toLowerCase();

  switch (normalizedValue) {
    case "in-house":
      return EnumLabelType.InHouse;
    case "private label":
      return EnumLabelType.PrivateLabel;
    default: {
      const foundKey = joinByCapitalLetter(EnumLabelType, normalizedValue);
      return EnumLabelType[foundKey as keyof typeof EnumLabelType];
    }
  }
};

export default {
  getKeyFromValue,
  splitByCapitalLetter,
  joinByCapitalLetter,
  getLabelTypeString,
  getLabelTypeFromString,
};
